const serialRegex = /^[a-zA-Z0-9\ \-]*$/; // eslint-disable-line no-useless-escape
const yearRegex = /^[0-9\-]*$/; // eslint-disable-line no-useless-escape

export const messages = {
  commentsError: 'Please provide your comments.',
  locationLength: 'Please provide only the purchase location.',
  preferredContactError: 'Please provide your preferred contact method.',
  serialError: 'Please provide a valid serial number.',
  serialLength: 'Please only provide a serial number.',
  yearLength: 'Please enter a year in the format yyyy.',
};

export const runSpecialValidation = (
  formState,
  preferredContactMethod,
  submitPressed,
  customMessages
) => {
  let additionalErrors = {};
  const errorMessages = { ...messages, ...customMessages };

  if (formState.serial && formState.serial.touched) {
    if (!formState.serial.value) {
      additionalErrors.serial = errorMessages.serialError;
    } else if (!serialRegex.test(formState.serial.value.trim())) {
      additionalErrors.serial = errorMessages.serialError;
    } else if (formState.serial.value.length > 50) {
      additionalErrors.serial = errorMessages.serialLength;
    }
  }
  if (formState.location && formState.location.touched) {
    if (formState.location.value.length > 50) {
      additionalErrors.location = errorMessages.locationLength;
    }
  }
  if (formState.year && formState.year.touched) {
    if (!yearRegex.test(formState.year.value.trim())) {
      additionalErrors.year = errorMessages.yearLength;
    } else if (
      formState.year.value.trim().length !== 4 &&
      formState.year.value.trim() !== ''
    ) {
      additionalErrors.year = errorMessages.yearLength;
    }
  }
  if (formState.comments && formState.comments.touched) {
    // added a check for empty (only spaces) comment because sumbitCATForm will fail (bad request) when posted if empty comment
    if (
      !formState.comments.value ||
      formState.comments.value.trim().length == 0
    ) {
      additionalErrors.comments = errorMessages.commentsError;
    }
  }
  if (preferredContactMethod === null && submitPressed) {
    additionalErrors.preferredContact = errorMessages.preferredContactError;
  }

  additionalErrors.hasErrors =
    Object.keys(additionalErrors).filter((k) => !!additionalErrors[k]).length >
    0;

  return additionalErrors;
};
